import { useEffect, useState } from "react";
import { parse } from "papaparse";

export default function useParseCSV(file){
    const [parsed, setParsed] = useState(null);
    
    useEffect(()=>{
        let destroyed = false;
        if(file){
            parse(file, {
                complete: result=>{
                    if(!destroyed) setParsed(result.data);
                },
                error: error=>{
                    console.warn('error parsing csv', error);
                    if(!destroyed) setParsed(null);
                }
            })
        }else if(parsed){
            setParsed(null);
        }
        return ()=>{
            destroyed = true;
        }
    },[file]);

    return parsed;
}